module.exports = __webpack_public_path__ + "static/media/2.7.04a9bad8.png";